<template>
  <div class="weeks">
    <va-card :title="$t('weeksRanking.cards.title')">
      <va-data-table
        :fields="fields"
        :data="ranking"
        :per-page="perPage"
        :totalPages="totalPages"
        :loading="loading"
        @page-selected="showMore"
        no-data-label="Sem Dados Cadastrados"
        api-mode
        class="table-h"
      >
      </va-data-table>
    </va-card>
  </div>
</template>

<script>
import gql from 'graphql-tag'

const perPage = 6
export default {
  name: 'WeekRanking',
  methods: {
    showMore (page) {
      this.loading = true
      this.page = page
      this.$apollo.queries.ranking.fetchMore({
        variables: {
          page: (page - 1) * this.perPage,
          perPage: this.perPage,
        },
        updateQuery: (_, { fetchMoreResult }) => {
          this.loading = false
          return fetchMoreResult
        },
      })
    },
  },
  data () {
    return {
      ranking: [],
      page: 1,
      perPage: perPage,
      pages: null,
      loading: false,
    }
  },
  apollo: {
    ranking: {
      query: gql`
      query MyQuery($page: Int, $perPage: Int) {
        ranking(limit: $perPage, offset: $page) {
          client_id
          client {
            firstName
            lastName
          }
          result
          result2x
          resultpts
          since
        }
      }
      `,
      variables () {
        return {
          perPage,
          page: 0,
        }
      },
    },
    pages: {
      query: gql`
      query MyQuery {
        pages: ranking_aggregate {
          aggregate {
            count
          }
        }
      }
      `,
    },
  },
  computed: {
    totalPages () {
      return this.pages != null ? Math.ceil(this.pages.aggregate.count / this.perPage) : 0
    },
    fields () {
      const moment = this.$moment
      return [
        {
          name: 'client_id',
          title: this.$t('weeksRanking.headings.id'),
          dataClass: 'text-center',
          width: '100px',
        },
        {
          name: 'client',
          title: this.$t('weeksRanking.headings.name'),
          callback (value) {
            return value.firstName + ' ' + value.lastName
          },
        },
        {
          name: 'result',
          title: this.$t('weeksRanking.headings.result'),
          width: '10%',
        },
        {
          name: 'result2x',
          title: this.$t('weeksRanking.headings.result2x'),
          width: '10%',
          callback (value) {
            return value != null ? value : 0
          },
        },
        {
          name: 'resultpts',
          title: this.$t('weeksRanking.headings.resultpts'),
          width: '10%',
        },
        {
          name: 'since',
          title: this.$t('weeksRanking.headings.since'),
          width: '20%',
          callback (value) {
            return moment(value).format('DD/MM/YYYY [as] HH:mm:ss')
          },
        },
      ]
    },
  },
  mounted () {
    if (Object.keys(this.$apollo.queries).includes('ranking')) {
      this.$apollo.queries.pages.refetch()
      this.$apollo.queries.ranking.refetch()
    }
  },
}
</script>

<style lang="scss">
.table-h {
  min-height: 500px;
}
</style>
